import { logoSymbol } from "@/assets";
import HelmetMetaData from "@/components/HelmetMetaData";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import NewPasswordForm from "@/components/forms/NewPasswordForm";
import AuthDisplay from "./components/AuthDisplay";

const NewPassword = () => {
  const [error, setError] = useState("");
  const [currentInputType, setCurrentInputType] = useState("password");
  const [confirmInputType, setConfirmInputType] = useState("password");
  const [resetCode, setResetCode] = useState("");
  // const { loading, postRequest } = usePostRequest();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      currentPassword: "",
      confirmPassword: "",
    },
  });

  // Retrieve the codeValidated from localStorage
  useEffect(() => {
    const storedPasskey = localStorage.getItem("passkey");
    if (storedPasskey) {
      setResetCode(storedPasskey);
    }
  }, []);

  // Remove Error while Typing
  useEffect(() => {
    setError("");
  }, [watch("confirmPassword"), watch("currentPassword")]);

  // Toggle Password Visibility for CurrentInputType
  const toggleCurrentPasswordVisibility = () => {
    setCurrentInputType((prevType) =>
      prevType === "password" ? "text" : "password",
    );
  };

  // Toggle Password Visibility for ConfirmInputType
  const toggleConfirmPasswordVisibility = () => {
    setConfirmInputType((prevType) =>
      prevType === "password" ? "text" : "password",
    );
  };

  // Submit Function
  const onSubmit = async (data) => {
    // if (data.currentPassword !== data.confirmPassword) {
    //   return setError("Passwords do not match. Please try again.");
    // }
    // if (data.confirmPassword.length < 8 || data.currentPassword.length < 8) {
    //   return setError("Both passwords must be at least 8 characters long.");
    // }
    // const url = "/api/user/update";
    // const dataToSend = new FormData();
    // dataToSend.append("code", resetCode);
    // dataToSend.append("password", data.confirmPassword);
    // const { onSuccess } = await postRequest(url, dataToSend);
    // if (onSuccess) {
    //   toast.success("Password Changed Successfully!");
    //   navigate("/login");
    // }
  };

  return (
    <>
      <HelmetMetaData
        title="Create New Password - Billzpay"
        description="Create a new password for your Billzpay account. Ensure your password is strong and secure to keep your account safe. Enjoy seamless payments and services once you're back in!"
      />

      <section
        style={{
          background:
            "linear-gradient(135deg, #223867 0%, #33559b 50%, #111c34 100%)",
        }}
        className="h-dvh overflow-y-hidden"
      >
        <div className="flex h-full w-full items-center justify-center border border-white/10 lg:flex-row lg:justify-start">
          <div className="dark:bg-darkBg relative h-full w-full overflow-hidden rounded-none bg-white p-5 md:h-[650px] md:w-[450px] lg:h-full lg:w-[40%] lg:px-10">
            <img
              src="/logo.svg"
              alt="billzpay-logo"
              className="absolute top-3 right-5 w-16 lg:w-14"
            />

            <div className="flex h-full w-full items-center">
              <div className="w-full rounded-3xl py-10 xl:p-10 xl:shadow-2xl">
                <motion.h2
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  className="font-archivo mb-2 text-[2.4rem] leading-[1.2] font-medium text-black/85"
                >
                  Pick a new password
                </motion.h2>

                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
                  className="leading-[1.3] text-gray-500"
                >
                  Create your account to get started with Billzpay
                </motion.p>

                <NewPasswordForm />

                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
                  className="absolute bottom-4 left-1/2 mt-10 -translate-x-1/2 text-xs text-gray-400 lg:mt-5"
                >
                  <p className="text-center">
                    By signing up, you agree to Billzpay <br />
                    <span className="font-medium text-black hover:underline">
                      Terms & Conditions
                    </span>{" "}
                    and{" "}
                    <span className="font-medium text-black hover:underline">
                      Privacy policy
                    </span>
                  </p>
                </motion.div>
              </div>
            </div>
          </div>

          <AuthDisplay />
        </div>
      </section>
    </>
  );
};

export default NewPassword;
